module.exports = __webpack_public_path__ + "img/PH_1000_1-1.b6f62fe2.png";